/**
 * <snake-delivery> (snippets/snake-delivery.liquid)
 * - Shows the latest arrival time for an order placed now: 24 hours from now, in Boston time.
 * - ZIP check against the list in data-zips (5-digit ZIPs, or 3-digit prefixes that cover a whole area).
 *   An entry starting with '-' excludes a ZIP or prefix (e.g. 021 -02190).
 *   The last ZIP checked is remembered in this browser only, so the answer shows again on the next page.
 */
const T = (key, fallback) => (window.SnakeI18n && window.SnakeI18n[key]) || fallback;
const ZIP_KEY = 'snk-zip';

function arrivalText() {
  const due = new Date(Date.now() + 24 * 60 * 60 * 1000);
  const lang = document.documentElement.lang || 'en';
  const fmt = new Intl.DateTimeFormat(lang.startsWith('zh') ? 'zh-CN' : 'en-US', {
    timeZone: 'America/New_York',
    weekday: 'short',
    hour: 'numeric',
    minute: '2-digit',
  });
  return T('eta', 'Order now, arrives by {time}').replace('{time}', fmt.format(due));
}

class SnakeDelivery extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = '1';

    const eta = this.querySelector('[data-eta]');
    if (eta) {
      const tick = () => {
        eta.textContent = arrivalText();
        eta.hidden = false;
      };
      tick();
      this.timer = window.setInterval(tick, 60 * 1000);
    }

    const form = this.querySelector('[data-zip-form]');
    if (!form) return;
    const input = /** @type {HTMLInputElement} */ (form.querySelector('[data-zip-input]'));
    const result = /** @type {HTMLElement} */ (form.querySelector('[data-zip-result]'));
    const list = (this.dataset.zips || '').split(/\s+/).filter(Boolean);

    const check = (raw, remember) => {
      const zip = String(raw || '').trim().slice(0, 5);
      result.hidden = false;
      result.classList.remove('is-ok', 'is-no');
      if (!/^\d{5}$/.test(zip)) {
        result.textContent = T('zip_invalid', 'Enter a 5-digit ZIP code.');
        return;
      }
      const hit = (z) => (z.length === 5 ? z === zip : zip.startsWith(z));
      const ok = list.some((z) => !z.startsWith('-') && hit(z)) && !list.some((z) => z.startsWith('-') && hit(z.slice(1)));
      result.textContent = (ok ? T('zip_ok', 'Good news, we deliver to {zip}.') : T('zip_no', "Sorry, we don't deliver to {zip} yet.")).replace('{zip}', zip);
      result.classList.add(ok ? 'is-ok' : 'is-no');
      if (remember) {
        try {
          localStorage.setItem(ZIP_KEY, zip);
        } catch (e) {}
      }
    };

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      check(input.value, true);
    });

    try {
      const saved = localStorage.getItem(ZIP_KEY);
      if (saved) {
        input.value = saved;
        check(saved, false);
      }
    } catch (e) {}
  }

  disconnectedCallback() {
    if (this.timer) window.clearInterval(this.timer);
    delete this.dataset.ready;
  }
}

if (!customElements.get('snake-delivery')) customElements.define('snake-delivery', SnakeDelivery);
